export default __webpack_public_path__ + "static/media/edit-profile-icon.ac4b2c92.svg";